// URL.parse / URL.canParse are static WHATWG additions that landed in
// browsers after this app's 2024 support baseline (see .browserslistrc) —
// e.g. Safari added them in 17.4 (March 2024), other engines later that year.
// pdfjs-dist v5 (pulled in via react-pdf) calls URL.parse() directly, which
// crashes as "URL.parse is not a function" on browsers older than that.
if (typeof URL.parse !== 'function') {
  URL.parse = (url, base) => {
    try {
      return new URL(url, base);
    } catch {
      return null;
    }
  };
}

if (typeof URL.canParse !== 'function') {
  URL.canParse = (url, base) => {
    try {
      new URL(url, base);
      return true;
    } catch {
      return false;
    }
  };
}
